import { __require as p } from "./index133.js";
import { __require as q } from "./index134.js";
import { __require as _ } from "./index135.js";
var i, s;
function j() {
  if (s) return i;
  s = 1;
  var t = p(), n = q(), o = _(), f = Object.prototype, u = f.toString;
  function c(e) {
    return u.call(e) === "[object Date]";
  }
  function a(e) {
    return u.call(e) === "[object Number]";
  }
  i = function(r) {
    return c(r) ? r : a(r) ? new Date(b(r)) : t.is(r) ? t.parse(r) : n.is(r) ? n.parse(r) : o.is(r) ? o.parse(r) : new Date(r);
  };
  function b(e) {
    return e < 315576e5 ? e * 1e3 : e;
  }
  return i;
}
export {
  j as __require
};
//# sourceMappingURL=index111.js.map
